module.exports = __webpack_public_path__ + "static/media/5.c18caf83.jpg";